import axios from "axios";
import constants from "../constants";

const {
  GET_ACHIEVEMENTS, GET_ACHIEVEMENTS_SUCCESS, GET_ACHIEVEMENTS_ERROR,
  ADD_ACHIEVEMENT, ADD_ACHIEVEMENT_SUCCESS, ADD_ACHIEVEMENT_ERROR,
  EDIT_ACHIEVEMENT, EDIT_ACHIEVEMENT_SUCCESS, EDIT_ACHIEVEMENT_ERROR,
  DELETE_ACHIEVEMENT, DELETE_ACHIEVEMENT_SUCCESS, DELETE_ACHIEVEMENT_ERROR
} = constants;

const ADD_ACHIEVEMENT_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/add-achievement";
const GET_ACHIEVEMENTS_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/get-achievements";
const EDIT_ACHIEVEMENT_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/update-achievement";
const DELETE_ACHIEVEMENT_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/delete-achievement";


export const getAchievementsAction = (config) => async (dispatch) => {
  dispatch({ type: GET_ACHIEVEMENTS })
  await axios.get(GET_ACHIEVEMENTS_API_END_POINT, config)
    .then((res) => dispatch({ type: GET_ACHIEVEMENTS_SUCCESS, achievements: res?.data?.achievements }))
    .catch((error) => dispatch({ type: GET_ACHIEVEMENTS_ERROR, error }))
}

export const addAchievementAction = (data, config, callback1, callback2) => async (dispatch) => {
  dispatch({ type: ADD_ACHIEVEMENT })
  await axios.post(ADD_ACHIEVEMENT_API_END_POINT, data, config)
    .then((res) => {
      dispatch({ type: ADD_ACHIEVEMENT_SUCCESS, message: res?.data?.message })
      if (typeof callback1 === 'function') callback1();
      if (typeof callback2 === 'function') callback2();
    })
    .catch((error) => dispatch({ type: ADD_ACHIEVEMENT_ERROR, error }))
}

export const updateAchievementAction = (update, config, callback1, callback2) => async (dispatch) => {
  dispatch({ type: EDIT_ACHIEVEMENT })
  await axios.post(EDIT_ACHIEVEMENT_API_END_POINT, {update}, config)
    .then((res) => {
      dispatch({ type: EDIT_ACHIEVEMENT_SUCCESS, message: res?.data?.message })
      if (typeof callback1 === 'function') callback1();
      if (typeof callback2 === 'function') callback2();
    })
    .catch((error) => dispatch({ type: EDIT_ACHIEVEMENT_ERROR, error }))
}

export const deleteAchievementAction = (data, config, callback) => async (dispatch) => {
  dispatch({ type: DELETE_ACHIEVEMENT })
  await axios.post(DELETE_ACHIEVEMENT_API_END_POINT, data, config)
    .then((res) => {
      dispatch({ type: DELETE_ACHIEVEMENT_SUCCESS, message: res?.data?.message })
      if (typeof callback === 'function') callback();
    })
    .catch((error) => dispatch({ type: DELETE_ACHIEVEMENT_ERROR, error }))
}

